
namespace SP {
    


    export interface CustomerInfo {
        stockId: string;
        customerId: string;
        customerName: string;
        //autofillPackage: boolean;
        allowLocationScanPicking: number;
        address: Address;
        defaultReturnReasonId: string;
        defaultReturnActionId: string;
        defaultReturnMethod: ReturnMethod;
        deliveryMethods: { [methodKey: string]: DeliveryMethod};
    }
}